import React from 'react';
import T from 'prop-types';
// components
import Icon from '../../../components/Icon/Icon';
//styles
import styles from './NavButton.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

const NavButton = ({
  children,
  onClick,
  direction,
  type = 'button',
  disabled
}) => (
  <button
    onClick={onClick}
    type={type}
    disabled={disabled}
    className={cn(styles.button, direction, { disabled })}
  >
    {children}
    <Icon
      type={`arrow-${direction === 'prev' ? 'left' : 'right'}-long`}
      className={styles.buttonIcon}
    />
  </button>
);

NavButton.propTypes = {
  children: T.string.isRequired,
  onClick: T.func,
  direction: T.oneOf(['next', 'prev']),
  type: T.oneOf(['submit', 'button'])
};

export default NavButton;



// WEBPACK FOOTER //
// ./src/containers/Module/components/NavButton.jsx